'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg24 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 25, height: 25, viewBox: "0 0 25 25", fill: "none" }, props),
    React__namespace.createElement("path", { d: "M11.021 3.90904C11.5064 3.45789 12.2657 3.48572 12.7169 3.9712C13.168 4.45668 13.1402 5.21597 12.6547 5.66712L6.93642 10.9811C6.59364 11.2996 6.30803 11.5658 6.06977 11.7961L22.6705 11.7961C23.3333 11.7961 23.8706 12.3333 23.8706 12.9961C23.8706 13.6588 23.3333 14.1961 22.6705 14.1961L5.99555 14.1961C6.24807 14.4427 6.55727 14.7309 6.93639 15.0832L12.5845 20.332C13.0699 20.7832 13.0978 21.5424 12.6466 22.0279C12.1954 22.5134 11.4362 22.5412 10.9507 22.0901L5.24452 16.7873C4.55597 16.1475 3.95076 15.5852 3.5288 15.0685C3.07307 14.5105 2.70446 13.8579 2.70447 13.0321C2.70447 12.2063 3.07309 11.5537 3.52882 10.9957C3.95078 10.4791 4.55597 9.91677 5.24448 9.27703L11.021 3.90904Z", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg24;
//# sourceMappingURL=24.js.map
